const content = [
  // 第一章 第六节 Vocational Focus
  // 小标题
  {
    key: 'section6',
    type: "title",
    category: 7, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: "Vocational Focus", // *必填* 标题文本内容
    titleImage: require("@/assets/images/books/book2/title-back.png"),
    textStyle: {
        // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
        fontSize: 38, // 文字大小  默认：26
        // lineHeight: 40, // 行高  默认：46
        textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#5CA683', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
        // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
        marginTop: 24,
    },
  },
  {
    key: 'section6.0',
    type: "title",
    category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: "Celebrate Festivals in the Workplace", // *必填* 标题文本内容
    textStyle: {
        fontFamily: 'Arial', // 字体，本地配置的字体
        fontSize: 32, // 文字大小  默认：26
        lineHeight: 36, // 行高  默认：46
        textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#333333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
        // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
        marginTop: 30,
    },
  },
  // 模板样式 单个带边框
  {
    key: 'section6.1',
    type: 'template',
    category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
    templateStyle: {
      // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
      // fontSize: 38, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#5CA683', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      marginTop: 30,
      // marginBottom: 30,
      padding: 25,
      backgroundColor: '#D2E3D9',
      // paddingTop: 0,
      // paddingBottom: 0,
      borderRadius: 0,
      border: 'none',
      borderTop: 'none',
      borderBottom: 'none',
      borderLeft: '6rem solid #5CA683',
      borderRight: 'none'
    },
    content: [
      { //右侧文本内容，目前只有一段文字
        key: 'section6.1.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        isInTable: true,
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
          {
            key: 'section6.1.1.1', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: 'Willy works as an assistant editor. One of his job duties is organizing teambuilding activities. The Dragon Boat Festival is coming. Willy plans to organize a team-building activity in the department to celebrate the Dragon Boat Festival.', // *必填* 文本内容
            textStyle: {},
          }
        ],
        textStyle: {
          fontFamily: 'Calibri', // 字体，本地配置的字体
          fontSize: 28, // 文字大小  默认：20
          lineHeight: 42, // 行高  默认：36
          textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#333', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
      },
    ],
  },
  {
    key: 'section6.2',
    type: 'paragraph',
    category: 'withBefore',
    leftMark: { // 左侧标记
      type: 'block', // block: 左侧占满 inline：仅第一行有缩进
      width: 55,
      height: 40,
      text: 'I',
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        fontSize: 24, // 文字大小  默认：20
        lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#fff', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#5CA683', // 背景颜色  默认：无
        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
        paddingLeft: 0,
        paddingRight: 15,
        marginLeft: 0,
        marginRight: 14,
        marginTop: 0,
        marginBottom: 0,
        top: 0,
        left: 0,
      }
    },
    content: { //右侧文本内容，目前只有一段文字
      key: 'section6.2.1', // *必填* 唯一标识
      type: 'text', // *必填* 类型：正文
      isInTable: true,
      content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
        {
          key: 'section6.2.1.1', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本
          text: 'If you are Willy, you’d like to __________.', // *必填* 文本内容
          textStyle: {
            fontSize: 28, // 文字大小  默认：20
            lineHeight: 38, // 行高  默认：36
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          },
        }
      ],
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        // fontSize: 20, // 文字大小  默认：20
        // lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
      },
    },
    // 段落内外间距
    paragraphStyle: {
        marginTop: 34,
        marginBottom: 0,
        padding: 0,
        paddingLeft: 24,
        paddingRight: 24,
    }
  },
  {
    key: 'section6.3',
    type: 'selectWithImage',
    content: {
      selectOptions: [
        {
          key: 'section6.3.1',
          imgUrl: require("@/assets/images/books/book2/question/select-img-1.png"),
          text: 'create a video about  celebrating the Dragon  Boat Festival',
          label: 'A.  ',
        },
        {
          key: 'section6.3.2',
          imgUrl: require("@/assets/images/books/book2/question/select-img-2.png"),
          text: 'send a festival gift to your colleagues, like a zongzi gift box',
          label: 'B.  ',
        },
        {
          key: 'section6.3.3',
          imgUrl: require("@/assets/images/books/book2/question/select-img-3.png"),
          text: 'go out for dinner together',
          label: 'C.  ',
        },
        {
          key: 'section6.3.4',
          imgUrl: require("@/assets/images/books/book2/question/select-img-4.png"),
          text: 'hold an office party',
          label: 'D.  ',
        },
      ]
    }
  },
  {
    key: 'section6.4',
    type: 'paragraph',
    category: 'withBefore',
    leftMark: { // 左侧标记
      type: 'block', // block: 左侧占满 inline：仅第一行有缩进
      width: 55,
      height: 40,
      text: 'II',
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        fontSize: 24, // 文字大小  默认：20
        lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#fff', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#5CA683', // 背景颜色  默认：无
        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
        paddingLeft: 0,
        paddingRight: 15,
        marginLeft: 0,
        marginRight: 14,
        marginTop: 0,
        marginBottom: 0,
        top: 0,
        left: 0,
      }
    },
    content: { //右侧文本内容，目前只有一段文字
      key: 'section6.4.1', // *必填* 唯一标识
      type: 'text', // *必填* 类型：正文
      isInTable: true,
      content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
        {
          key: 'section6.4.1.1', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本
          text: 'Critical thinking', // *必填* 文本内容
          textStyle: {
            fontSize: 28, // 文字大小  默认：20
            lineHeight: 38, // 行高  默认：36
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          },
        }
      ],
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        // fontSize: 20, // 文字大小  默认：20
        // lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
      },
    },
    // 段落内外间距
    paragraphStyle: {
        marginTop: 34,
        marginBottom: 0,
        padding: 0,
        paddingLeft: 24,
        paddingRight: 24,
    }
  },
  // 模板样式 单个带边框
  {
    key: 'section6.5',
    type: 'template',
    category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
    templateStyle: {
      // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
      // fontSize: 38, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#5CA683', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      marginTop: 20,
      marginBottom: 44,
      padding: 20,
      backgroundColor: '#FFFFFF',
      // paddingTop: 0,
      paddingBottom: 0,
      borderRadius: 10,
    },
    content: [
      {
        key: 'section6.5.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        isInTable: true,
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
          {
            key: 'section6.5.1.1', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: 'Choose another traditional Chinese festival and think about the ways to celebrate it in the workplace. ', // *必填* 文本内容
            textStyle: {},
          }
        ],
        textStyle: {
          fontFamily: 'Calibri', // 字体，本地配置的字体
          fontSize: 28, // 文字大小  默认：20
          lineHeight: 38, // 行高  默认：36
          textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#333', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
      },
      {
        key: 'section6.5.2', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        isInTable: true,
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
          {
            key: 'section6.5.2.1', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: 'Then share your ideas with your classmates.', // *必填* 文本内容
            textStyle: {},
          }
        ],
        textStyle: {
          fontFamily: 'Calibri', // 字体，本地配置的字体
          fontSize: 28, // 文字大小  默认：20
          lineHeight: 38, // 行高  默认：36
          textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#333', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
      },
      {
        key: 'section6.5.3',
        type: "sound",
        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "", // *必填* 标题文本内容
        titleImageType: 3,
        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
        textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontSize: 26, // 文字大小  默认：26
            height: 49,
            width: 'auto',
            lineHeight: 49, // 行高  默认：46
            maxWidth: 500,
            // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#fff', // 文本颜色  默认：#00a8ac
            backgroundColor: '#5CA683', // 背景颜色  默认：无
            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
            borderRadius: {
                borderTopLeftRadius: 20,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 20,
                borderBottomLeftRadius: 0
            }
        },
    },
    ],
  },
]
export default content
